export default __webpack_public_path__ + "static/media/16.0902adb9.png";